import { cn } from "../../lib/cn";

export function Skeleton({ className }: { className?: string }) {
  return (
    // A soft sky tint rather than grey, so loading blocks belong to the pastel scene.
    <div aria-hidden="true" className={cn("animate-pulse rounded-lg bg-sky-100/70", className)} />
  );
}
